import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { AuthEnums } from "models/enums";
import { ApiClientInstance, LocalizationHelperInstance, EnumHelper } from "utils/helpers";
import { ServiceConstants, TodoConstants } from "utils/constants";

/**
 * @deprecated This service is deprecated. Use useTodoService hook instead.
 *
 * @see useTodoService - The replacement hook
 * @see https://app.clickup.com/4523827/v/dc/4a1tk-21632/4a1tk-8592
 */
const TodoService = {
  getTodos: (page: number, key?: number) => {
    return ApiClientInstance(AuthEnums.AuthType.Company)
      .TodoClient.Get({
        ...ServiceConstants.DefaultFilter,
        page: page,
        numPerPage: TodoConstants.TodosPerPage,
        excludeSnoozed: true,
        types: TodoConstants.SupportingTodoTypes,
      })
      .then((data) => ({ ...data.data, key: key }));
  },

  getTodosByFilter: (filter: WintSuperkollAPIModel.TodoFilter, key?: number) => {
    return ApiClientInstance(AuthEnums.AuthType.Company)
      .TodoClient.Get(filter)
      .then((res) => {
        return { result: res, key: key };
      });
  },

  getTodoTypesForReportFilter: () => {
    return EnumHelper.getNumericItemValues(WintSuperkollAPIModel.TodoType).filter((t) =>
      TodoConstants.SupportingTodoTypes.includes(t)
    );
  },

  getTodoHeaderText: (item: WintSuperkollAPIModel.Todo) => {
    return LocalizationHelperInstance.getFormattedMessage(
      `Todos.TodoCardName_${WintSuperkollAPIModel.TodoSubType[item.subType].toString()}`,
      "",
      item.subType === WintSuperkollAPIModel.TodoSubType.AgentSaleMissingInformation
        ? {
            externalSystemName: item.agentSaleMissingInformation?.externalSystemName ?? "",
          }
        : undefined
    );
  },

  getTodoSummary: () => {
    return ApiClientInstance(AuthEnums.AuthType.Company)
      .TodoClient.TodoSummary({ types: TodoConstants.SupportingTodoTypes, isSnoozed: false })
      .then((res) => res.data);
  },
};

export default TodoService;
